// extracted by mini-css-extract-plugin
var _1 = "SliderFormValueItem_actions__70e1a";
var _2 = "SliderFormValueItem_active__e52e7";
var _3 = "SliderFormValueItem_root__17a35";
var _4 = "SliderFormValueItem_title__6d0da";
export { _1 as "actions", _2 as "active", _3 as "root", _4 as "title" }
